import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AIChatbot from './components/AIChatbot';
import AnalyticsTracker from './components/AnalyticsTracker';
import ScrollToTop from './components/ScrollToTop';
import SolutionLanding from './pages/SolutionLanding';
import Security from './pages/Security';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';
import { I18nProvider } from './i18n/I18nContext';

const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const Products = lazy(() => import('./pages/Products'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Contact = lazy(() => import('./pages/Contact'));
const ServiceRequest = lazy(() => import('./pages/ServiceRequest'));
const CaseStudies = lazy(() => import('./pages/CaseStudies'));
const Blog = lazy(() => import('./pages/Blog'));
const AIFlagship = lazy(() => import('./pages/AIFlagship'));
const DataEngineeringLanding = lazy(() => import('./pages/DataEngineeringLanding'));
const DigitalMarketingLanding = lazy(() => import('./pages/DigitalMarketingLanding'));
const Team = lazy(() => import('./pages/Team'));
const About = lazy(() => import('./pages/About'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <I18nProvider>
    <Router>
      <div className="App">
        <ScrollToTop />
        <AnalyticsTracker />
        <Navbar />
        <main>
          <Suspense fallback={<div className="route-loading">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/service-request" element={<ServiceRequest />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/team" element={<Team />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/solutions" element={<Navigate to="/solutions/web-development" replace />} />
              <Route path="/solutions/data-engineering" element={<DataEngineeringLanding />} />
              <Route path="/solutions/digital-marketing" element={<DigitalMarketingLanding />} />
              <Route
                path="/solutions/web-development"
                element={
                  <SolutionLanding
                    title="Web Development for Growth-Stage Teams"
                    subtitle="Conversion-focused and scalable web platforms designed for speed, reliability, and business outcomes."
                    outcomes={['Faster page loads', 'Higher conversion rates', 'Clean architecture for scale']}
                    stack={['React', 'Next.js', 'Django', 'Node.js', 'PostgreSQL', 'Cloudflare']}
                    ctaPath="/service-request"
                  />
                }
              />
              <Route
                path="/solutions/mobile-development"
                element={
                  <SolutionLanding
                    title="Mobile Apps with Product-Market Fit Focus"
                    subtitle="Cross-platform and native app delivery with clear milestones and user engagement strategy."
                    outcomes={['Launch in weeks, not months', 'Better retention metrics', 'Store-ready quality process']}
                    stack={['React Native', 'Flutter', 'Kotlin', 'Swift', 'Firebase', 'Supabase']}
                    ctaPath="/service-request"
                  />
                }
              />
              <Route
                path="/solutions/ai-solutions"
                element={<AIFlagship />}
              />
              <Route path="/security" element={<Security />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <AIChatbot />
      </div>
    </Router>
    </I18nProvider>
  );
}

export default App;
